import React from 'react';
import PropTypes from 'prop-types';

const PDPOverview = ({ description, overview }) => <>
    <p className="u-margin-top">{description}</p>
    <p dangerouslySetInnerHTML={{ __html: overview }} />
  </>

export default PDPOverview;

PDPOverview.propTypes = {
  description: PropTypes.string.isRequired,
  overview: PropTypes.string,
};

PDPOverview.defaultProps = {
  overview: '',
};
